import { render, staticRenderFns } from "./SubmitIcon.vue?vue&type=template&id=78514fb0&scoped=true"
import script from "./SubmitIcon.vue?vue&type=script&lang=js"
export * from "./SubmitIcon.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "78514fb0",
  null
  
)

export default component.exports